module.exports = { "default": require("core-js/library/fn/reflect/set"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/set.js
// module id = 274
// module chunks = 7